// extracted by mini-css-extract-plugin
module.exports = {"banner":"BannerSmall_banner__F7o9y"};